<template>
	<section class="container">
		<section id="saved-list" class="side-padding">
			<div class="header">
				<h1>{{ $t("shared_page.title") }}</h1>
			</div>
			<div class="toolbox">
				<div class="column">
					<!-- <Dropdown
						:options="sortOptions"
						:selected="sort_by"
						selectName="savedListSortBy"
						@update="setSort"
						v-if="shared_list"
					></Dropdown> -->
					<div class="print-export-btns">
						<download-excel
							:fetch="exportData"
							:fields="exportLabels"
							type="csv"
							:escapeCsv="false"
							:name="$t('shared_page.title') + '.csv'"
						>
							<button id="export">
								<span id="exportTooltip" class="tooltiptext">{{
									$t("labels.export_saved")
								}}</span>
								<span class="label-small sr-only">{{ $t("labels.export_saved") }}</span>
							</button>
						</download-excel>
						<button id="print" @click="printPage">
							<span id="printTooltip" class="tooltiptext">{{
								$t("labels.print_saved")
							}}</span>
							<span class="label-small sr-only">{{ $t("labels.print_saved") }}</span>
						</button>
					</div>
				</div>
			</div>
			<div class="grid-list-container">
				<MySavedList 
					class="saved-list" 
					:results="shared_list"
					:allResults="all_shared_items"
					viewType="shared" 
					v-if="shared_list"></MySavedList>
				<div v-else class="empty-state">
					{{ $t("shared_page.empty_text") }}
				</div>

				<!-- pagination -->
				<Pagination 
					v-if="ids.length > 100"
					:currentPage="currentPage"
					:totalPages="totalPages"
					@turn="changePage"></Pagination>
			</div>

			<SelectedBar action="save"></SelectedBar>
		</section>
		<section class="end-page-content">
			<ResourceCenter></ResourceCenter>
			<JsonLD :data="json_ld"></JsonLD>
		</section>
	</section>
</template>

<script>
import { mapGetters } from "vuex";
import JsonLD from "../components/JsonLD";
import ResourceCenter from "../components/ResourceCenter";
import MySavedList from "../components/MySavedList";
// import Dropdown from "../components/Dropdown";
import SelectedBar from "../components/SelectedBar";
import Pagination from "../components/Pagination";

export default {
	components: {
		JsonLD,
		ResourceCenter,
		MySavedList,
		// Dropdown,
		SelectedBar,
		Pagination,
	},
	head() {
		return {
			title: function() {
				return {
					inner: this.$i18n.t("shared_page.title"),
					separator: "|",
					complement: this.$i18n.t(`main.${this.site}.museum_name`),
				};
			},
			meta: function() {
				return [
					{
						rel: "canonical",
						href: this.$i18n.t(`main.${this.site}.cannonical`),
						id: "rel-con",
					},
					{
						rel: "alternate",
						href: this.$i18n.t(`main.${this.site}.alternate`),
						hreflang: this.$i18n.t(`main.${this.site}.alternate_locale`),
						id: "rel-alt",
					},

					{
						name: "description",
						content: this.$i18n.t(`main.${this.site}.description`),
						id: "desc",
					},

					{
						property: "og:title",
						content: `${this.$i18n.t(
							`main.${this.site}.site_name`
						)} | ${this.$i18n.t(`main.${this.site}.museum_name`)}`,
						id: "og-title",
					},
					{
						property: "og:description",
						content: this.$i18n.t(`main.${this.site}.cannonical`),
						id: "og-desc",
					},
					{ property: "og:type", content: "website", id: "og-type" },
					{
						property: "og:locale",
						content: this.$i18n.locale,
						id: "og-locale",
					},
					{
						property: "og:image",
						content: `${window.location.host}${this.$i18n.t(
							`main.${this.site}.preview_image`
						)}`,
						id: "og-image",
					},
				];
			},
		};
	},
	data: function() {
		return {
			sortOptions: [
				{
					text: this.$i18n.messages[this.$i18n.locale].sort_options[
						"title_asc"
					],
					value: "title,asc",
				},
				{
					text: this.$i18n.messages[this.$i18n.locale].sort_options[
						"title_desc"
					],
					value: "title,desc",
				},
			],
			exportLabels: this.$i18n.messages[this.$i18n.locale].csv_headers,
			ids: []
		};
	},
	computed: {
		...mapGetters({
			sort_by: "list/sort_by",
			saved_items: "list/saved_items",
			all_shared_items: "list/all_shared_items",
			shared_list: "list/shared_list",
			site: "search/site",
			json_ld: "list/json_ld",
			currentPage: "list/current_page",
			'results': 'results/list_results',
		}),
		json_ld() {
			let page_content = this.$i18n.messages[this.$i18n.locale].shared_page;
			let json = {
				"@type": "CollectionPage",
				name: page_content.title,
				url: window.location.href,
				mainEntity: [
					{
						"@type": "ItemList",
						name: page_content.title,
					},
				],
			};

			return json;
		},
		totalPages() {
			if (this.ids) {
				return new Array(Math.ceil(this.ids.length / 100));
			} else {
				return []
			}
		},
	},
	methods: {
		async setSort(sort) {
			if (sort != this.sort_by) {
				await this.$store.dispatch("list/sort_by", sort);
				this.fetchList()
			}
		},
		async fetchList(params = {}) {
			params.ids = this.ids;
			params.site = this.site;
			params.locale = this.$i18n.locale;
			params.page = params.page ? params.page : this.currentPage;
			params.urlString = this.$route.fullPath.split('?')[1];

			this.$store.dispatch('list/fetchShared',  params)
		},
		printPage() {
			window.print();
		},
		async changePage(page) {
			await this.getPage(page);
			this.$router.replace({ name: 'shared-list', query: {page: page, ids: this.ids.join(',')} })
		},
		getPage(page) {
			if (page <= this.totalPages.length && page > 0) {
				this.fetchList({ 
					page: page,
				});
			}
		},
		async exportData() {
			let data = [];
			let path = window.location.href.split("/");
			path.pop();
			path.shift();


			this.all_shared_items.forEach((item) => {
				let newItem = { ...item };
				let itemPath = item.path
					.split("/")
					.splice(2, 2)
					.join("/");
				newItem["path"] = `https:/${path.join("/")}/${itemPath}`;
				if (item.media) {
					newItem["media"] = item.media.url;
					newItem["media.mime_type"] = item.media.mime_type;
				}

				if (Object.keys(newItem).includes("artist_maker")) {
					newItem["names"] = newItem["artist_maker"];
				}
				if (Object.keys(newItem).includes("cultural_group")) {
					newItem["affiliation"] = newItem["cultural_group"];
				}

				if (Object.keys(newItem).includes("unit_dates")) {
					newItem["date_made"] = newItem["unit_dates"];
				}

				// Add quotation so the csv doesn't break when we have a coma
				for (let key in newItem) {
					newItem[key] = '"' + newItem[key] + '"';
				}

				data.push(newItem);
			});

			return data;
		},
	},
	async mounted() {
		this.$store.dispatch("list/clearSelected")
		this.$store.dispatch("search/type", { type: "all" });

		let page = this.$route.query['page'] ? this.$route.query['page'] : 1;
		await this.getPage(page);

		let hasUrlQuery = Object.keys(this.$route.query).length > 0;
		if (hasUrlQuery) {
			let data = this.$route.query;

			this.ids = data['ids'].split(',')
			this.fetchList();

			await this.$store.dispatch('list/fetchAllShared', {
				site: this.site,
				locale: this.$i18n.locale,
				size: 500,
				page: 1,
				type: 'all',
				ids: this.ids
			})

			this.$emit('updateHead')
		}
	},
};
</script>

<style scoped lang="scss">
#saved-list {
	position: relative;
	background: $off-white;

	.print-export-btns {
		display: flex;
		justify-content: flex-end;
		padding: 0 0;
		text-align: right;

		button {
			background: none;
			border: none;
			display: inline-flex;
			align-items: center;
			margin-left: 1.375rem;
			cursor: pointer;
			position: relative;

			span {
				padding-right: $s1;
				color: $menu-gray;
			}
		}

		#export:after {
			content: url("../assets/images/icon-download-excel.svg");
			display: flex;
			justify-content: center;
			align-items: center;
		}
		#print:after {
			content: url("../assets/images/icon-print.svg");
			display: flex;
			justify-content: center;
			align-items: center;
		}
		#share:after {
			content: url("../assets/images/icon_share.svg");
			display: flex;
			justify-content: center;
			align-items: center;
		}
	}

	.toolbox{
		display: flex;
		justify-content: space-between;
		align-items: center;
		box-sizing: border-box;
		width: 100%;
		padding: 1.938rem 0 1.375rem;
		background: $off-white;
		position: sticky;
		top: -5px;
		z-index: 5;
		
		.column:last-child{
			display: flex;
			justify-content: flex-end;
			align-items: center;
		}
	}
	.toolbox,
	.header,
	.grid-list-container {
		max-width: 1600px;
		margin: 0 auto;
	}

	.empty-state {
		margin-top: $s4;
		font-size: $s2;
	}

	a {
		color: $dark-gray1;
		text-decoration: underline;
	}

	.header {
		padding-top: 2rem;
		display: flex;
		justify-content: space-between;
		background: $off-white;
		z-index: 3;

		h1 {
			margin-top: 0;
		}
	}

	.grid-list-container {
		padding-bottom: 5rem;
	}

	thead th{
		background-color: $off-white;
	}

	@media print {
		.header,
		.toolbox,
		.print-export-btns,
		.end-page-content {
			display: none;
		}
	}
}

#share {
	margin-left: 6px;
	display: inline-block;
}

.tooltiptext {
	visibility: hidden;
	width: 120px;
	background-color: #555;
	color: #fff !important;
	text-align: center;
	border-radius: 6px;
	padding: 5px;
	position: absolute;
	z-index: 4;
	bottom: 150%;
	left: -90%;
	opacity: 0;
	transition: opacity 0.3s;
	box-sizing: border-box;
}

.tooltiptext::after {
	content: "";
	position: absolute;
	top: 100%;
	left: 50%;
	margin-left: -5px;
	border-width: 5px;
	border-style: solid;
	border-color: #555 transparent transparent transparent;
}

button:hover .tooltiptext {
	visibility: visible;
	opacity: 1;
}

@media (max-width: $mq-max-width-tablet) {
	h1 {
		font-size: 1.5rem;
		margin-bottom: 0;
		line-height: 2;
	}
	.toolbox{
		padding: 1.25rem 0 2.25rem !important;
		flex-direction: column-reverse;
		flex-wrap: wrap;

		.column{
			width: 100%;
			box-sizing: border-box;
		}
		.column:last-child{
			width: 100%;
			justify-content: flex-start !important;			
			margin-bottom: 2.563rem;
		}
	}
}

@media (max-width: $mq-max-width-mobile) {
	.toolbox {
		.column:last-child{
			margin-bottom: $s1;
		}
	}
}
</style>
